var _desc, _g, _script;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCpu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/icons-category/cpu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/icons-category/cpu",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-workstation",
    transform: "translate(2.000000, 8.000000)",
    fill: "#0D6EFD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,29.6875 L12.5,29.6875 L12.5,0 L0,0 Z M14.0625,0 L14.0625,3.125 L37.5,3.125 L37.5,20.3125 L14.0625,20.3125 L14.0625,23.4375 L21.875,23.4375 L21.875,26.5625 L15.625,26.5625 L15.625,29.6875 L31.25,29.6875 L31.25,26.5625 L25,26.5625 L25,23.4375 L40.625,23.4375 L40.625,0 L14.0625,0 Z M3.125,3.125 L9.375,3.125 L9.375,26.5625 L3.125,26.5625 L3.125,3.125 Z M6.25,21.875 C5.38940469,21.875 4.6875,22.5769047 4.6875,23.4375 C4.6875,24.2980953 5.38940469,25 6.25,25 C7.11059531,25 7.8125,24.2980953 7.8125,23.4375 C7.8125,22.5769047 7.11059531,21.875 6.25,21.875 Z",
    id: "Shape"
  })))), _script || (_script = /*#__PURE__*/React.createElement("script", {
    type: "text/javascript"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpu);
export default __webpack_public_path__ + "static/media/cpu.3c0d987f6763f1a9c3a36f183883f6e6.svg";
export { ForwardRef as ReactComponent };